import React, { useState } from "react";
import "./HRPolicy.css";

const HRPolicy = () => {
  const [section1, setsection1] = useState(false);
  const [section2, setsection2] = useState(false);
  const [section3, setsection3] = useState(false);
  const [section4, setsection4] = useState(false);
  const [section5, setsection5] = useState(false);
  const [section6, setsection6] = useState(false);
  const [section7, setsection7] = useState(false);
  const [section8, setsection8] = useState(false);
  const [section9, setsection9] = useState(false);
  const [section10, setsection10] = useState(false);
  const [section11, setsection11] = useState(false);
  const [section12, setsection12] = useState(false);
  const [section13, setsection13] = useState(false);
  const [section14, setsection14] = useState(false);
  const [section15, setsection15] = useState(false);
  const style = {
    backgroundColor: "#00274E",
    color: "white",
    fontSize: "20px",
    border: "none",
    padding: "8px",
    borderRadius: "10px",
  };
  return (
    <div className="hr-container">
      <div className="hr-hero">
        <h1>Human Resources Policy</h1>
        <p>Career Point of Information Technology (CPIT) Educational Trust</p>
      </div>

      <div className="policy-section">
        <h2>1. Introduction</h2>

        {section1 && (
          <div>
            <ul>
              <li>
                <h5>About CPIT Educational Trust</h5>
              </li>
              <p>
                CPIT Educational Trust is committed to providing quality
                education, employee welfare, professional development, and
                maintaining a transparent work environment.
              </p>
              <li>
                <h5>Vision and Mission</h5>
              </li>
              <p>
                <span>Vision:</span> To be a premier institution for IT and
                skill-based education, creating digitally literate and
                employable youth who contribute meaningfully to society.
              </p>
              <p>
                <span>Mission:</span> To provide affordable, accessible, and
                quality education; foster innovation and critical thinking; and
                prepare students for successful careers in the digital economy.
              </p>
              <li>
                <h5>Core Values</h5>
              </li>
              <p>
                <span>Excellence: </span>Commitment to high standards in
                teaching, learning, and administration.
              </p>
              <p>
                <span>Integrity: </span>Ethical conduct, transparency, and
                accountability in all operations.
              </p>
              <p>
                <span>Inclusivity: </span>Equal opportunity and respect for
                diversity.
              </p>
              <p>
                <span>Innovation: </span>Encouraging creativity, continuous
                improvement, and adaptability.
              </p>
              <p>
                <span>Student-Centricity: </span>Prioritizing student welfare,
                learning outcomes, and career success.
              </p>
              <li>
                <h5>Objectives of this HR Manual</h5>
              </li>
              <p
                style={{
                  color: "black",
                }}
              >
                This HR Manual aims to:
              </p>
              <ul>
                <li
                  style={{
                    color: "#555",
                  }}
                >
                  Communicate organizational policies, procedures, and
                  expectations clearly
                </li>
                <li
                  style={{
                    color: "#555",
                  }}
                >
                  Ensure consistency, fairness, and transparency in HR practices
                </li>
                <li
                  style={{
                    color: "#555",
                  }}
                >
                  Promote compliance with applicable labor laws and regulations
                </li>
                <li
                  style={{
                    color: "#555",
                  }}
                >
                  Foster a positive, respectful, and productive work environment
                </li>
                <li
                  style={{
                    color: "#555",
                  }}
                >
                  Support employee development, performance management, and
                  career growth
                </li>
                <li
                  style={{
                    color: "#555",
                  }}
                >
                  Provide guidelines for recruitment, compensation, benefits,
                  conduct, and grievance resolution
                </li>
              </ul>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection1(!section1)}>
          {section1 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>2. Scope and Applicability</h2>
        {section2 && (
          <div>
            <p>
              This HR Manual applies to all employees of CPIT Educational Trust,
              including:
            </p>
            <ul>
              <li>
                <p>
                  <span>Teaching Staff: </span>Faculty, trainers, instructors,
                  and visiting lecturers
                </p>
              </li>
              <li>
                <p>
                  <span>Administrative Staff: </span>Directors, managers,
                  coordinators, and office personnel
                </p>
              </li>
              <li>
                <p>
                  <span>Support Staff: </span>Lab assistants, library staff,
                  housekeeping, and security personnel
                </p>
              </li>
            </ul>
            <p>
              All employees are expected to read, understand, and comply with
              the policies outlined in this manual. Management reserves the
              right to amend, modify, or update policies as necessary, with
              appropriate communication to all staff.
            </p>
          </div>
        )}

        <button style={style} onClick={() => setsection2(!section2)}>
          {section2 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>3. Recruitment & Selection</h2>
        {section3 && (
          <div>
            <ul>
              <li>
                <h5>Recruitment Policy</h5>
              </li>
              <p>
                CPIT follows a merit-based, transparent, and non-discriminatory
                recruitment process to attract qualified and competent
                individuals. Recruitment may be conducted for:
              </p>
              <ul>
                <li style={{ color: "#555" }}>Permanent positions</li>
                <li style={{ color: "#555" }}>Contract/temporary positions</li>
                <li style={{ color: "#555" }}>
                  Part-time or visiting faculty positions
                </li>
              </ul>
              <li>
                <h5>Eligibility Criteria</h5>
              </li>
              <p>
                All candidates must meet the minimum qualifications, experience,
                and competency requirements as specified in the job description.
                For teaching positions, candidates must possess relevant
                academic credentials and teaching experience as per NIELIT,
                university, or regulatory norms[3][4].
              </p>
              <li>
                <h5>Selection Process</h5>
              </li>
              <p>The selection process typically includes:</p>
              <p>
                <span>1. Advertisement: </span>Job openings advertised
                internally and externally through institutional channels,
                websites, and job portals.
              </p>
              <p>
                <span>2. Application Screening: </span>HR reviews applications
                for eligibility and shortlists candidates.
              </p>
              <p>
                <span>3. Written Test/Skill Assessment: </span>Where applicable,
                candidates may be required to complete a written test or
                practical demonstration.
              </p>
              <p>
                <span>4. Interview: </span>Shortlisted candidates are invited
                for an interview with a selection panel comprising senior
                faculty and management representatives.
              </p>
              <p>
                <span>5. Reference Check: </span>References and credentials are
                verified.
              </p>
              <p>
                <span>6. Offer Letter: </span>Selected candidates receive a
                formal offer letter outlining terms and conditions of
                employment.
              </p>
              <li>
                <h5>Equal Opportunity Employer</h5>
              </li>
              <p>
                CPIT is an equal opportunity employer and does not discriminate
                on the basis of caste, religion, gender, age, disability,
                marital status, or any other protected characteristic. Selection
                decisions are based solely on merit, qualifications, and
                suitability for the role[5][6].
              </p>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection3(!section3)}>
          {section3 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>4. Appointment & Probation</h2>
        {section4 && (
          <div>
            <ul>
              <li>
                <h5>Appointment Letter</h5>
              </li>
              <p>
                Upon acceptance of the offer, the candidate is issued an
                appointment letter specifying:
              </p>
              <ul>
                <li style={{ color: "#555" }}>
                  Job title and responsibilities
                </li>
                <li style={{ color: "#555" }}>
                  Department and reporting structure
                </li>
                <li style={{ color: "#555" }}>Compensation and benefits</li>
                <li style={{ color: "#555" }}>
                  Probation period (if applicable)
                </li>
                <li style={{ color: "#555" }}>Date of joining</li>
                <li style={{ color: "#555" }}>
                  Terms and conditions of employment
                </li>
              </ul>
              <li>
                <h5>Probation Period</h5>
              </li>
              <p>
                All new employees (teaching and non-teaching) are subject to a
                probation period of six months from the date of joining. During
                this period:
              </p>
              <ul>
                <li style={{ color: "#555" }}>
                  Performance, conduct, and suitability for the role are
                  assessed
                </li>
                <li style={{ color: "#555" }}>
                  Employees receive regular feedback and support
                </li>
                <li style={{ color: "#555" }}>
                  Either party may terminate employment with one month's notice
                  or as per terms
                </li>
              </ul>
              <p>
                Upon satisfactory completion of probation, employees are
                confirmed in their positions and issued a confirmation letter.
              </p>
              <li>
                <h5>Induction and Orientation</h5>
              </li>
              <p>
                All new employees undergo a comprehensive induction program,
                which includes:
              </p>
              <ul>
                <li style={{ color: "#555" }}>
                  Introduction to CPIT's vision, mission, values, and
                  organizational structure
                </li>
                <li style={{ color: "#555" }}>
                  Overview of HR policies, code of conduct, and safety protocols
                </li>
                <li style={{ color: "#555" }}>
                  Familiarization with institutional facilities, systems, and
                  procedures
                </li>
                <li style={{ color: "#555" }}>
                  Meeting with department heads and colleagues
                </li>
                <li style={{ color: "#555" }}>
                  Training on relevant software, tools, and teaching
                  methodologies
                </li>
              </ul>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection4(!section4)}>
          {section4 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>5. Employment Terms and Conditions</h2>
        {section5 && (
          <div>
            <ul>
              <li>
                <h5>Employment Categories</h5>
              </li>
              <p>
                <span>Full-Time Employees: </span>Regular employees working
                standard hours as per institutional norms.
              </p>
              <p>
                <span>Part-Time Employees: </span>Employees working fewer hours
                than full-time, with pro-rated benefits.
              </p>
              <p>
                <span>Contract/Temporary Employees: </span>Engaged for specific
                projects or periods, with terms defined in individual contracts.
              </p>
              <p>
                <span>Visiting Faculty: </span>External experts invited to
                deliver specialized courses or training sessions.
              </p>
              <li>
                <h5>Working Hours</h5>
              </li>
              <p>
                Standard working hours are{" "}
                <span>9:00 AM to 6:00 PM, Monday to Saturday,</span>
                with a one-hour lunch break. Specific departments or roles may
                have different schedules based on operational requirements.
                Teaching staff schedules are determined based on class
                timetables and academic calendars.
              </p>
              <li>
                <h5>Attendance and Punctuality</h5>
                <p>Employees are expected to:</p>
                <ul>
                  <li>
                    <p>Arrive on time and adhere to scheduled hours</p>
                  </li>
                  <li>
                    <p>
                      Mark attendance daily using the designated attendance
                      system
                    </p>
                  </li>
                  <li>
                    <p>
                      Inform their supervisor in advance in case of absence or
                      late arrival
                    </p>
                  </li>
                  <li>
                    <p>
                      Maintain a minimum attendance standard of 90% (for
                      teaching staff)
                    </p>
                  </li>
                </ul>
                <p>
                  Persistent absenteeism or tardiness may result in disciplinary
                  action[7].
                </p>
              </li>

              <li>
                <h5>Leave Policy</h5>
              </li>
              <ol>
                <li>
                  <h5>Types of Leave</h5>
                </li>
                <ul>
                  <li>
                    <p>
                      <span>Casual Leave (CL): </span>12 days per year for
                      personal or urgent matters. Cannot be carried forward.
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>Sick Leave (SL): </span> 10 days per year for
                      medical reasons. Medical certificate required for leave
                      exceeding three consecutive days.
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>Earned Leave (EL)/Privilege Leave: </span>15 days
                      per year, accumulative up to 30 days. May be encashed upon
                      resignation or retirement as per policy.
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>Maternity Leave: </span>Female employees are
                      entitled to 26 weeks of paid maternity leave as per the
                      Maternity Benefit Act, 1961.
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>Paternity Leave: </span>Male employees are entitled
                      to 15 days of paternity leave.
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>Bereavement Leave: </span>Up to 5 days in case of
                      death of an immediate family member (spouse, child,
                      parent, sibling).
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>Special Leave: </span>Granted at the discretion of
                      management for extraordinary circumstances.
                    </p>
                  </li>
                </ul>
                <li>
                  <h5>Leave Application Procedure</h5>
                </li>
                <ul>
                  <li>
                    <p>
                      Leave must be applied for in advance using the prescribed
                      leave application form
                    </p>
                  </li>
                  <li>
                    <p>
                      Emergency leave must be communicated immediately and
                      regularized within two working days
                    </p>
                  </li>
                  <li>
                    <p>
                      Leave approval is subject to operational requirements and
                      supervisor discretion
                    </p>
                  </li>
                  <li>
                    <p>
                      Unauthorized absence may result in loss of pay and
                      disciplinary action
                    </p>
                  </li>
                </ul>
              </ol>
              <li>
                <h5>Holidays</h5>
              </li>
              <p>
                CPIT observes all national and state holidays as per the
                government calendar. Additionally, institutional holidays may be
                declared for special occasions. The annual holiday list is
                communicated at the beginning of each academic year.
              </p>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection5(!section5)}>
          {section5 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>6. Compensation and Benefits</h2>
        {section6 && (
          <div>
            <ul>
              <li>
                <h5>Salary Structure</h5>
              </li>
              <p>
                Salaries are determined based on qualifications, experience,
                role, and market standards. The salary structure includes:
              </p>
              <ul>
                <li>
                  <span>Basic Salary</span>
                </li>
                <li>
                  <p>
                    <span>Allowances: </span>Dearness Allowance (DA), House Rent
                    Allowance (HRA), Transport Allowance, and other applicable
                    allowances
                  </p>
                </li>
                <li>
                  <p>
                    <span>Deductions: </span>Provident Fund (PF), Professional
                    Tax (PT), Tax Deducted at Source (TDS), and other statutory
                    deductions
                  </p>
                </li>
              </ul>
              <li>
                <h5>Payroll Processing</h5>
              </li>
              <p>
                Salaries are processed monthly and credited to employees' bank
                accounts by the <span>last working day of each month.</span>{" "}
                Salary slips are provided electronically or in hard copy,
                detailing earnings and deductions.
              </p>
              <li>
                <h5>Provident Fund (PF)</h5>
              </li>
              <p>
                All eligible employees are enrolled in the Employees' Provident
                Fund (EPF) scheme as per statutory requirements. Both employee
                and employer contribute <span>12% of basic salary</span> to the
                PF account.
              </p>
              <li>
                <h5>Gratuity</h5>
              </li>
              <p>
                Employees completing{" "}
                <span>five years of continuous service</span> are entitled to
                gratuity as per the Payment of Gratuity Act, 1972. Gratuity is
                calculated based on the last drawn salary and years of service.
              </p>
              <li>
                <h5>Performance Incentives</h5>
              </li>
              <p>
                High-performing employees may be eligible for performance-based
                incentives, bonuses, or salary increments as determined by
                management during annual appraisals.
              </p>
              <li>
                <h5>Professional Development Support</h5>
              </li>
              <p>CPIT supports employee development through:</p>
              <ul>
                <li>
                  <p>
                    Sponsorship for training programs, workshops, and
                    conferences
                  </p>
                </li>
                <li>
                  <p>
                    Tuition reimbursement for relevant professional courses or
                    certifications
                  </p>
                </li>
                <li>
                  <p>Access to online learning platforms and resources</p>
                </li>
              </ul>
              <li>
                <h5>Employee Welfare Benefits</h5>
              </li>
              <ul>
                <li>
                  <p>
                    <span>Medical Benefits: </span>Group health insurance or
                    medical reimbursement as per policy
                  </p>
                </li>
                <li>
                  <p>
                    <span>Subsidized Meals: </span>Canteen facilities at
                    subsidized rates (where available)
                  </p>
                </li>
                <li>
                  <p>
                    <span>Transport Assistance: </span>Support for commuting
                    (where applicable)
                  </p>
                </li>
                <li>
                  <p>
                    <span>Fee Concession: </span>Tuition fee concession for
                    employees' children enrolled at CPIT
                  </p>
                </li>
              </ul>
            </ul>
          </div>
        )}
        <button style={style} onClick={() => setsection6(!section6)}>
          {section6 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>7. Performance Management</h2>
        {section7 && (
          <div>
            <ul>
              <li>
                <h5>Performance Appraisal System</h5>
              </li>
              <p>
                CPIT conducts annual performance appraisals to assess employee
                performance, identify strengths, and plan for development. The
                appraisal process includes:
              </p>
              <ul>
                <li>
                  <p>
                    <span>Self-Assessment: </span>Employees evaluate their own
                    performance against set objectives
                  </p>
                </li>
                <li>
                  <p>
                    <span>Supervisor Evaluation: </span>Immediate supervisors
                    assess performance based on predefined criteria
                  </p>
                </li>
                <li>
                  <p>
                    <span>Appraisal Discussion: </span>One-on-one meeting to
                    discuss performance, achievements, challenges, and
                    development plans
                  </p>
                </li>
                <li>
                  <p>
                    <span>Final Rating: </span>Consolidated rating and feedback
                    documented in the appraisal form
                  </p>
                </li>
              </ul>
              <li>
                <h5>Key Performance Indicators (KPIs)</h5>
              </li>
              <p>Performance is evaluated based on:</p>
              <ul>
                <li>
                  <p>
                    <span>Teaching Staff: </span>Classroom delivery, student
                    feedback, curriculum coverage, innovation in teaching,
                    research contributions, exam results
                  </p>
                </li>
                <li>
                  <p>
                    <span>Administrative Staff: </span>Task completion, quality
                    of work, teamwork, problem-solving, adherence to deadlines
                  </p>
                </li>
                <li>
                  <p>
                    <span>Support Staff: </span>Reliability, efficiency,
                    cooperation, service quality
                  </p>
                </li>
              </ul>
              <li>
                <h5>Career Development and Promotion</h5>
              </li>
              <p>High performers are considered for:</p>
              <ul>
                <li>
                  <p>Promotions to higher positions</p>
                </li>
                <li>
                  <p>Salary increments and bonuses</p>
                </li>
                <li>
                  <p>Leadership roles and additional responsibilities</p>
                </li>
                <li>
                  <p>
                    Opportunities for further training and skill enhancement
                  </p>
                </li>
              </ul>
              <li>
                <h5>Performance Improvement Plan (PIP)</h5>
              </li>
              <p>
                Employees not meeting performance expectations may be placed on
                a Performance Improvement Plan (PIP), which includes:
              </p>
              <ul>
                <li>
                  <p>Clear identification of performance gaps</p>
                </li>
                <li>
                  <p>Specific, measurable improvement goals</p>
                </li>
                <li>
                  <p>Support and resources to achieve improvement</p>
                </li>
                <li>
                  <p>Regular monitoring and feedback</p>
                </li>
                <li>
                  <p>Defined timeline (typically 3-6 months)</p>
                </li>
              </ul>
              <p>
                Failure to meet PIP objectives may result in reassignment,
                demotion, or termination[8][9].
              </p>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection7(!section7)}>
          {section7 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>8. Professional Conduct and Ethics</h2>
        {section8 && (
          <div>
            <ul>
              <li>
                <h5>Code of Conduct</h5>
              </li>
              <p>All employees are expected to:</p>
              <ul>
                <li>
                  <p>
                    Maintain professionalism, integrity, and ethical behavior at
                    all times
                  </p>
                </li>
                <li>
                  <p>Respect colleagues, students, and stakeholders</p>
                </li>
                <li>
                  <p>
                    Comply with institutional policies, rules, and regulations
                  </p>
                </li>
                <li>
                  <p>Avoid conflicts of interest</p>
                </li>
                <li>
                  <p>Protect confidential and proprietary information</p>
                </li>
                <li>
                  <p>
                    Refrain from any form of harassment, discrimination, or
                    misconduct
                  </p>
                </li>
              </ul>
              <li>
                <h5>Dress Code</h5>
              </li>
              <p>
                Employees should dress in a manner that is professional, modest,
                and appropriate for an educational environment. Specific dress
                code requirements may vary by department or role.
              </p>
              <li>
                <h5>Punctuality and Discipline</h5>
              </li>
              <p>
                Employees must adhere to schedules, meet deadlines, and maintain
                discipline. Any breach of conduct may result in disciplinary
                action.
              </p>
              <li>
                <h5>Use of Institutional Resources</h5>
              </li>
              <p>
                Institutional property, equipment, and resources (computers,
                internet, library, vehicles) are to be used for official
                purposes only. Misuse or damage may result in penalties or
                disciplinary action.
              </p>
              <li>
                <h5>Prohibition of Harassment</h5>
              </li>
              <p>
                CPIT maintains a zero-tolerance policy toward harassment of any
                kind—sexual, verbal, physical, or psychological. Any employee
                experiencing or witnessing harassment must report immediately to
                HR or management. Complaints will be investigated promptly and
                confidentially, and appropriate action will be taken[10][11].
              </p>
              <li>
                <h5>Substance Abuse</h5>
              </li>
              <p>
                Consumption of alcohol, drugs, or any intoxicating substances on
                institutional premises is strictly prohibited. Employees found
                under the influence during working hours will face immediate
                disciplinary action, including termination.
              </p>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection8(!section8)}>
          {section8 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>9. Health, Safety, and Welfare</h2>
        {section9 && (
          <div>
            <ul>
              <li>
                <h5>Workplace Safety</h5>
              </li>
              <p>
                CPIT is committed to providing a safe and healthy work
                environment. Employees are expected to:
              </p>
              <ul>
                <li>
                  <p>Follow safety protocols and guidelines</p>
                </li>
                <li>
                  <p>
                    Report hazards, accidents, or unsafe conditions immediately
                  </p>
                </li>
                <li>
                  <p>Participate in safety training and drills</p>
                </li>
                <li>
                  <p>Use protective equipment where required</p>
                </li>
              </ul>
              <li>
                <h5>Medical Emergencies</h5>
              </li>
              <p>
                First aid facilities are available on campus. In case of medical
                emergencies, employees should contact HR or administration
                immediately. Emergency contact information is displayed at
                prominent locations.
              </p>
              <li>
                <h5>Health Insurance</h5>
              </li>
              <p>
                Eligible employees are covered under group health insurance or
                medical reimbursement schemes. Details of coverage, claim
                procedures, and network hospitals are provided separately.
              </p>
              <li>
                <h5>Employee Assistance</h5>
              </li>
              <p>
                CPIT provides support for employees facing personal or
                professional challenges through counseling services, financial
                assistance (in exceptional cases), and flexible work
                arrangements where feasible.
              </p>
            </ul>
          </div>
        )}
        <button style={style} onClick={() => setsection9(!section9)}>
          {section9 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>10. Grievance Redressal</h2>
        {section10 && (
          <div>
            <ul>
              <li>
                <h5>Grievance Procedure</h5>
              </li>
              <p>
                Employees with concerns or grievances regarding workplace
                matters may:
              </p>
              <ul>
                <li>
                  <p>
                    <span>Informal Resolution: </span>Discuss the issue with
                    immediate supervisor or department head
                  </p>
                </li>
                <li>
                  <p>
                    <span>Formal Complaint:</span>Submit a written grievance to
                    HR or management if informal resolution is unsuccessful
                  </p>
                </li>
                <li>
                  <p>
                    <span>Investigation: </span>HR will investigate the matter
                    impartially and confidentially
                  </p>
                </li>
                <li>
                  <p>
                    <span>Resolution:</span>Appropriate action will be taken,
                    and the employee will be informed of the outcome
                  </p>
                </li>
              </ul>
              <li>
                <h5>Confidentiality</h5>
              </li>
              <p>
                All grievances are handled with strict confidentiality.
                Employees filing grievances in good faith will not face
                retaliation.
              </p>
              <li>
                <h5>Grievance Committee</h5>
              </li>
              <p>
                A Grievance Redressal Committee comprising senior faculty and
                management representatives is constituted to address serious or
                unresolved grievances. The committee meets as required to review
                cases and recommend action[12].
              </p>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection10(!section10)}>
          {section10 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>11. Separation and Exit</h2>
        {section11 && (
          <div>
            <ul>
              <li>
                <h5>Resignation</h5>
              </li>
              <p>
                Employees wishing to resign must submit a written resignation
                letter with the following notice periods:
              </p>
              <ul>
                <li>
                  <p>
                    <span>Teaching Staff: </span>Two months
                  </p>
                </li>
                <li>
                  <p>
                    <span>Administrative/Support Staff: </span>One month
                  </p>
                </li>
              </ul>
              <p>
                Notice period may be waived at management's discretion or by
                mutual agreement.
              </p>
              <li>
                <h5>Termination by Management</h5>
              </li>
              <p>CPIT may terminate employment:</p>
              <ul>
                <li>
                  <p>
                    For cause (misconduct, poor performance, breach of contract)
                  </p>
                </li>
                <li>
                  <p>
                    Due to organizational restructuring or financial constraints
                  </p>
                </li>
                <li>
                  <p>
                    Upon completion of contract period (for temporary/contract
                    staff)
                  </p>
                </li>
              </ul>
              <p>
                Termination procedures will comply with applicable labor laws
                and terms of employment.
              </p>
              <li>
                <h5>Exit Interview</h5>
              </li>
              <p>
                All departing employees are invited for an exit interview with
                HR to provide feedback on their experience, discuss reasons for
                leaving, and facilitate knowledge transfer.
              </p>
              <li>
                <h5>Full and Final Settlement</h5>
              </li>
              <p>
                Upon separation, employees will receive full and final
                settlement including:
              </p>
              <ul>
                <li>
                  <p>
                    Salary for the notice period or payment in lieu of notice
                  </p>
                </li>
                <li>
                  <p>Encashment of earned leave (as applicable)</p>
                </li>
                <li>
                  <p>Gratuity (if eligible)</p>
                </li>
                <li>
                  <p>Provident Fund withdrawal or transfer</p>
                </li>
              </ul>
              <p>
                All institutional property (ID cards, keys, books, equipment)
                must be returned before final settlement.
              </p>
              <li>
                <h5>Experience and Service Certificates</h5>
              </li>
              <p>Relieved employees will be issued:</p>
              <ul>
                <li>
                  <p>
                    <span>Relieving Letter: </span>Confirming last working day
                    and satisfactory completion of duties
                  </p>
                </li>
                <li>
                  <p>
                    <span>Experience Certificate: </span>Detailing tenure,
                    designation, and responsibilities
                  </p>
                </li>
              </ul>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection11(!section11)}>
          {section11 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>12. Training and Development</h2>
        {section12 && (
          <div>
            <ul>
              <li>
                <h5>Continuous Professional Development</h5>
              </li>
              <p>
                CPIT is committed to the ongoing development of its employees.
                Training and development initiatives include:
              </p>
              <ul>
                <li>
                  <p>
                    <span>Orientation Programs: </span>For new employees
                  </p>
                </li>
                <li>
                  <p>
                    <span>In-Service Training: </span>Regular workshops on
                    pedagogy, technology, and domain knowledge
                  </p>
                </li>
                <li>
                  <p>
                    <span>External Training: </span>Sponsorship for conferences,
                    seminars, and certification programs
                  </p>
                </li>
                <li>
                  <p>
                    <span>Online Learning: </span>Access to e-learning platforms
                    and digital resources
                  </p>
                </li>
                <li>
                  <p>
                    <span>Mentorship Programs: </span>Pairing new faculty with
                    experienced mentors
                  </p>
                </li>
              </ul>
              <li>
                <h5>Training Budget</h5>
              </li>
              <p>
                CPIT allocates a dedicated budget for faculty and staff
                development annually. Employees may apply for training
                opportunities through their department heads.
              </p>
              <li>
                <h5>Training Evaluation</h5>
              </li>
              <p>Training effectiveness is evaluated through:</p>
              <ul>
                <li>
                  <p>Post-training assessments</p>
                </li>
                <li>
                  <p>Feedback surveys</p>
                </li>
                <li>
                  <p>Application of learning in job performance</p>
                </li>
                <li>
                  <p>Impact on student outcomes and institutional goals</p>
                </li>
              </ul>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection12(!section12)}>
          {section12 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>13. Communication and Engagement</h2>
        {section13 && (
          <div>
            <ul>
              <li>
                <h5>Internal Communication</h5>
              </li>
              <p>CPIT maintains open and transparent communication through:</p>
              <ul>
                <li>
                  <p>Staff meetings and departmental meetings</p>
                </li>
                <li>
                  <p>Email and official communication channels</p>
                </li>
                <li>
                  <p>Notice boards and circulars</p>
                </li>
                <li>
                  <p>Institutional intranet or WhatsApp groups</p>
                </li>
              </ul>
              <li>
                <h5>Employee Engagement</h5>
              </li>
              <p>CPIT fosters a positive work culture through:</p>
              <ul>
                <li>
                  <p>Recognition and awards for outstanding contributions</p>
                </li>
                <li>
                  <p>
                    Celebration of festivals, Annual Day, Teacher's Day, and
                    other events
                  </p>
                </li>
                <li>
                  <p>Team-building activities and social gatherings</p>
                </li>
                <li>
                  <p>Employee feedback and suggestion mechanisms</p>
                </li>
              </ul>
              <li>
                <h5>Feedback Mechanism</h5>
              </li>
              <p>
                Employees are encouraged to provide feedback on policies,
                procedures, and workplace matters. Anonymous feedback channels
                are available to ensure candid input[13][14].
              </p>
            </ul>
          </div>
        )}

        <button style={style} onClick={() => setsection13(!section13)}>
          {section13 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>14. Compliance and Legal Framework</h2>
        {section14 && (
          <div>
            <ul>
              <li>
                <h5>Compliance with Laws</h5>
              </li>
              <p>
                CPIT complies with all applicable central and state labor laws,
                including but not limited to:
              </p>
              <ul>
                <li>
                  <p>The Payment of Wages Act, 1936</p>
                </li>
                <li>
                  <p>The Minimum Wages Act, 1948</p>
                </li>
                <li>
                  <p>
                    The Employees' Provident Funds and Miscellaneous Provisions
                    Act, 1952
                  </p>
                </li>
                <li>
                  <p>The Payment of Gratuity Act, 1972</p>
                </li>
                <li>
                  <p>The Maternity Benefit Act, 1961</p>
                </li>
                <li>
                  <p>
                    The Sexual Harassment of Women at Workplace (Prevention,
                    Prohibition and Redressal) Act, 2013
                  </p>
                </li>
                <li>
                  <p>The Shops and Establishments Act (Uttar Pradesh)</p>
                </li>
              </ul>
              <li>
                <h5>Statutory Registrations</h5>
              </li>
              <p>
                CPIT maintains all necessary registrations and licenses required
                under law, including:
              </p>
              <ul>
                <li>
                  <p>Trust registration</p>
                </li>
                <li>
                  <p>PF and ESI registration</p>
                </li>
                <li>
                  <p>Professional Tax registration</p>
                </li>
                <li>
                  <p>GST registration</p>
                </li>
              </ul>
              <li>
                <h5>Data Protection and Privacy</h5>
              </li>
              <p>
                Employee personal information is handled with confidentiality
                and in compliance with data protection norms. Access to
                personnel records is restricted to authorized personnel
                only[15].
              </p>
            </ul>
          </div>
        )}
        <button style={style} onClick={() => setsection14(!section14)}>
          {section14 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>15. Amendment and Review</h2>
        {section15 && (
          <div>
            <ul>
              <li>
                <h5>Policy Review</h5>
              </li>
              <p>
                This HR Manual is reviewed annually and updated as necessary to
                reflect changes in law, organizational structure, or best
                practices.
              </p>
              <li>
                <h5>Right to Modify</h5>
              </li>
              <p>
                CPIT Educational Trust reserves the right to amend, modify, add
                to, or delete any policy or provision in this manual at any
                time. Employees will be notified of significant changes through
                official communication.
              </p>
              <li>
                <h5>Questions and Clarifications</h5>
              </li>
              <p>
                Employees with questions or requiring clarification on any
                policy should contact the HR Department.
              </p>
            </ul>
          </div>
        )}
        <button style={style} onClick={() => setsection15(!section15)}>
          {section15 ? "Less Content" : "Read More"}
        </button>
      </div>

      <div className="policy-section">
        <h2>Acknowledgment</h2>
        <p>
          All employees are required to read this HR Manual carefully and
          acknowledge receipt and understanding. By accepting employment with
          CPIT Educational Trust, employees agree to abide by the policies and
          procedures outlined in this manual.
        </p>
      </div>
      <div className="policy-section">
        <h2>Conclusion</h2>
        <p>
          This HR Manual represents CPIT Educational Trust's commitment to
          creating a fair, transparent, and supportive work environment.
          Together, we strive to achieve excellence in education, foster
          professional growth, and contribute positively to society.
        </p>
        <p>
          We look forward to your valuable contributions and wish you a
          fulfilling and successful career with CPIT.
        </p>
      </div>

      <div className="hr-footer">
        <h3>Human Resources Department</h3>
        <p>Career Point of Information Technology (CPIT)</p>
        <p>Badi Bagh Chungi, Near Honda Agency</p>
        <p>Ghazipur, Uttar Pradesh - 233001</p>
      </div>
    </div>
  );
};

export default HRPolicy;
